import 'html2pdf.js';

let logoBase64Container;

export function initPdfExport() {
  const exportPdfButton = document.getElementById('export_pdf');
  if (!exportPdfButton) return;

  exportPdfButton.onclick = _e => { generatePdf() };
}

async function generatePdf() {
  const exportPdfButton = document.getElementById('export_pdf');
  const pdfFilename = exportPdfButton.dataset.pdfFilename;
  const pdfDisclaimer = exportPdfButton.dataset.pdfDisclaimer;
  const pdfSelectedProfiles = exportPdfButton.dataset.pdfSelectedProfiles;

  const element = document.querySelector('main.container');

  const footerMarginFromBottom = 20
  const opts = {
    pagebreak: { mode: 'css', before: '.pdf-break-before', avoid: '.pdf-break-avoid'},
    margin: [0, 0, footerMarginFromBottom + 10, 0],
    html2canvas: {
      scale: 2,
      backgroundColor: null,
      width: 1400,
      useCORS: true,
    },
    jsPDF: {
      orientation: 'portrait',
      format: [495, 371],
    }
  }

  createTitlesForTables(element);
  const logoContainer = await createLogoForPdf();
  element.prepend(logoContainer);
  await html2pdf()
    .set(opts)
    .from(element)
    .toContainer()
    .then(async () => {
      await modifyHtmlTemplate(pdfSelectedProfiles);
    })
    .toPdf()
    .get('pdf')
    .then(pdf => addDisclaimerFooter(pdf, pdfDisclaimer))
    .save(pdfFilename);

  element.querySelectorAll('.cloned-node').forEach(node => node.remove());
}

async function modifyHtmlTemplate(pdfSelectedProfiles) {
  const logoContainer = await createLogoForPdf();
  const clonedDoc = $('.html2pdf__container');

  removeUnselectedTabs(clonedDoc);
  removeProfileFilterButton(clonedDoc);
  addLogoEachPage(clonedDoc, logoContainer);
  showClonedNodes(clonedDoc);
  updateDocStyles(clonedDoc);
  addSelectedProfiles(clonedDoc, pdfSelectedProfiles);
}

function removeUnselectedTabs(doc) {
  const unselectedFundStatisticsTab = doc.find("[id$='-fund-statistics-tab'][aria-selected='false']")
  const unselectedCumulativeCashFlowTab = doc.find("[id$='-cumulative-cashflow-tab'][aria-selected='false']")
  const unselectedAnnualCashFlowTab = doc.find("[id$='-annual-cashflow-tab'][aria-selected='false']")
  unselectedFundStatisticsTab.hide()
  unselectedCumulativeCashFlowTab.hide()
  unselectedAnnualCashFlowTab.hide()
}

function removeProfileFilterButton(doc) {
  // We need to hide() this element, instead of using `data-html2canvas-ignore="true"`,
  // because otherwise it messes up the pagebreak rendering when the h1 title
  // is as long as the page width.
  doc.find('#profileFiltersModalToggle').hide();
}

function addSelectedProfiles(doc, pdfSelectedProfiles) {
  const profileNamesSection = doc.find('section#selected_profile_names');
  const profileLabels = doc
    .find("label[for^='profile_id_']")
    .map((_idx, tag) => tag.innerText).get().join(', ');

  let profilesTitle = document.createElement('h2');
  profilesTitle.classList.add('text-primary', 'fs-4', 'fw-bold', 'mb-3');
  profilesTitle.innerText = pdfSelectedProfiles;

  profileNamesSection.append(profilesTitle, profileLabels);
  profileNamesSection.addClass('text-black mb-4 font-weight-bold title-font-family').css('font-size', '1.5rem');
}

function showClonedNodes(doc) {
  doc.find('.cloned-node').css('visibility', 'visible');
}

function updateDocStyles(doc) {
  // Center data
  doc.find('main.container').css('margin', '7rem auto 0');

  // Remove top margin and update page-break height
  doc.find('#annualCashFlowsChartTitle').first().removeClass('my-5').addClass('mb-5');

  // Fix #individual-annual-fundraising-distribution-container page break and logo placement
  const annualContainer = doc.find('#individual-annual-fundraising-distribution-container').first();
  annualContainer.addClass('pt-5');
  annualContainer.prev().css('top', '+=48');
}

function addDisclaimerFooter(pdf, pdfDisclaimer) {
  const totalPages = pdf.internal.getNumberOfPages();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const pageWidth = pdf.internal.pageSize.getWidth();

  for (let count = 1; count <= totalPages; count++) {
    let marginFromLeft = 10
    let marginFromBottom = pageHeight - 20

    pdf.setPage(count); // set footer on every page
    pdf.setFont('helvetica', 'italic')
    pdf.setFontSize(10);
    pdf.setTextColor(150);
    pdf.text(
      pdfDisclaimer,
      marginFromLeft,
      marginFromBottom,
      { align: 'justify', maxWidth: pageWidth - 20 },
    );
  }
}

function createTitlesForTables(element) {
  const cumulativeTitle = element.querySelector('#cumulativeAnnualCashFlowChartTitle').cloneNode(true);
  const cumulativeContent = element.querySelector('#individual-cumulative-fundraising-distribution-content');
  cumulativeTitle.style.visibility = 'hidden';
  cumulativeTitle.classList.add('cloned-node');
  cumulativeContent.parentElement.prepend(cumulativeTitle);

  // Cloning #annualCashFlowsChartTitle means, we clone "pdf-break-before" class too so we have another page break
  const annualTitle = element.querySelector('#annualCashFlowsChartTitle').cloneNode(true);
  const annualContent = element.querySelector('#individual-annual-fundraising-distribution-content');
  annualTitle.style.visibility = 'hidden';
  annualTitle.classList.add('cloned-node');
  annualTitle.classList.remove('pdf-break-before');
  annualContent.parentElement.prepend(annualTitle);
}

async function createLogoForPdf() {
  if (logoBase64Container) {
    return logoBase64Container;
  }

  const logoData = await imageUrlToBase64(document.querySelector('.logo-size').src);
  const logoPdf = document.createElement('img');
  logoPdf.src = logoData;
  logoPdf.classList.add('logo-size');

  const logoContainer = document.createElement('div');
  logoContainer.style.justifyContent = 'center';
  logoContainer.style.alignItems = 'center';
  logoContainer.style.display = 'flex';
  logoContainer.style.visibility = 'hidden';
  logoContainer.style.position = 'fixed';
  logoContainer.style.top = 0;
  logoContainer.style.right = 0;
  logoContainer.style.left = 0;
  logoContainer.classList.add('bg-primary', 'cloned-node');
  logoContainer.style.padding = '1rem';
  logoContainer.append(logoPdf);

  logoBase64Container = logoContainer;

  return logoContainer;
}

async function imageUrlToBase64(url) {
  const response = await fetch(
    url,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Accept': 'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
      },
      cache: 'no-store',
    }
  );
  const blob = await response.blob();

  return new Promise((onSuccess, onError) => {
    try {
      const reader = new FileReader() ;
      reader.onload = function(){ onSuccess(this.result) } ;
      reader.readAsDataURL(blob) ;
    } catch(error) {
      onError(error);
    }
  });
};

function addLogoEachPage(doc, logo) {
  $(logo).insertBefore(doc.find('.pdf-break-before'));
  const logoContainers = doc.find('div.bg-primary.cloned-node');
  const breakContainers = logoContainers.prev();

  breakContainers.each((index, container) => {
    // Index + 1 for the logos, since there's the first page logo;
    logoContainers[index + 1].style.top = `${container.offsetTop + container.offsetHeight - (2.5 * (index + 1))}px`;
  });
}
